import { useSwiper } from "swiper/react";

export default function SwiperNavigation() {
  const swiper = useSwiper();
  return (
    <div className="absolute w-full flex justify-between items-center top-1/2 left-0 right-0 h-12">
      <div
        onClick={() => swiper.slidePrev()}
        className="w-12 cursor-pointer relative z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-full h-full text-primary"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </div>
      <div
        onClick={() => swiper.slideNext()}
        className="w-12 cursor-pointer z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-full h-full text-primary"
        >
          <path d="M9 18l6-6-6-6" />
        </svg>
      </div>
    </div>
  );
}
